import axios from "axios";
import Cookies from "js-cookie";

// const baseUrl = "http://localhost:6002";
// const frontendUrl = "http://localhost:3000";

const baseUrl = "https://api.droneplanet.in";
const frontendUrl = "https://droneplanet.in";

export const createOrder = async (data) => {
  const url = baseUrl + `/createOrder`;

  const {
    addressId,
    paymentType,
    paymentGateway,
    amount,
  } = data;

  const returnURL = frontendUrl + "/paymentCallback";
  const paymentWebhook = baseUrl + "/paymentWebhook";

  try {
    const response = await axios.post(
      url,
      {
        addressId,
        paymentType,
        paymentGateway,
        returnURL,
        paymentWebhook,
        amount,
      },
      {
        headers: {
          token: Cookies.get("token"),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ createOrder error:", error);
    throw error;
  }
};

export const createOrderr = async (data) => {
  const url = baseUrl + `/createOrderr`;

  const paymentWebhook = baseUrl + "/paymentWebhook";
  const returnURL = frontendUrl + "/paymentCallback";

  const {
    addressId,
    paymentType,
    paymentGateway,
    amount,
  } = data;

  try {
    const response = await axios.post(
      url,
      {
        addressId,
        paymentType,
        paymentGateway,
        returnURL,
        paymentWebhook,
        amount,
      },
      {
        headers: {
          token: Cookies.get("token"),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ createOrderr error:", error);
    throw error;
  }
};